const apiUrl = process.env.REACT_APP_API_URL;

const getLubricantByCustomer = (token, erpid, cb) => {
    fetch(`${apiUrl}/LubricantsByERP/${erpid}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
        }
    })
        .then(res => res.json())
        .then(res => {
            cb(res);
        });
};

export default getLubricantByCustomer;
